/* eslint-disable import/no-absolute-path */
/* eslint-disable import/no-unresolved */
import reactNativeSVG from 'assets/resources/pages/software-services/logo/react_native2.png';
import flutterSVG from 'assets/resources/pages/software-services/logo/flutter2.png';
import ionicSVG from 'assets/resources/pages/software-services/logo/ionic2.svg';

export default [
  {
    src: reactNativeSVG,
    nameClass: 'img-fluid',
    alt: 'React Native'
  },
  {
    src: flutterSVG,
    nameClass: 'img-fluid',
    alt: 'Flutter'
  },
  {
    src: ionicSVG,
    nameClass: 'img-fluid',
    alt: 'Ionic'
  }
]